import { logout } from '../../auth.service';
import Login from '../../../pages/Login';

const FranquiaC = () =>
{    
    localStorage.setItem("tenantId", "franquiac");
    localStorage.setItem("logoVertical", "logoSampleclient");
    logout();
    
    return Login();
};

export default FranquiaC;